import { CollaboratorsApiRemoteService } from '../../Services/api/collaborators/collaborators-service'
import { ICollaboratorEntity, ICollaboratorListResponse, IListCollaboratorsPayload } from '../../Services/api/collaborators/collaborators.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowCollaboratorsUseCase
implements IFormUsecase<string, ICollaboratorEntity> {
  constructor (private readonly CollaboratorsApi: CollaboratorsApiRemoteService) {}
    

  public async handle (customerId: string): Promise<Result<ICollaboratorEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CollaboratorsApi.show(customerId)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
